import { PlatformDatabase } from '../database';
import { DefaultErrors } from '../../model/error';
import checkJwtToken from './check-jwt-expiration';
import refreshAccessToken from './refresh-access-token';
import Log from '../../util/log';

let accessToken: string | undefined;

let refreshToken: Promise<string> | undefined;

export default async function getAccessToken(
  db: PlatformDatabase,
  platformUrl: string,
  appId: string | undefined,
  wafToken: string | undefined = undefined,
): Promise<string> {
  if (accessToken && checkJwtToken(accessToken)) {
    return accessToken;
  }
  if (!refreshToken) {
    if (appId) {
      refreshToken = db.config
        .findOne(appId)
        .exec()
        .then((document) => {
          const refresh: string | undefined = document?.get('refreshToken');
          return refreshAccessToken(refresh, platformUrl, appId, wafToken)
            .then((token: string) => {
              accessToken = token;
              refreshToken = undefined;
              return token;
            })
            .catch((error) => {
              refreshToken = undefined;
              if (
                error === DefaultErrors.INVALID_USER_SESSION ||
                error === DefaultErrors.AWS_WAF_CAPTCHA_REQUIRED
              ) {
                throw error;
              }
              Log.error('Request App', error);
              throw DefaultErrors.UNABLE_TO_REFRESH_TOKEN;
            });
        })
        .finally(() => {
          refreshToken = undefined;
        });
    }
  }
  if (!refreshToken) {
    return Promise.reject(DefaultErrors.INVALID_USER_SESSION);
  }
  return refreshToken;
}
